<mat-sidenav-container class="h-screen flex">

  <mat-sidenav #sidenav mode="push" class="h-screen flex w-96">
    <app-sidenav (sidenavClose)="sidenav.close()"></app-sidenav>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="h-screen flex flex-col">

      <app-header class="flex-none sticky top-0 z-50" (sidenavToggle)="sidenav.toggle()" (sidenavClose)="sidenav.close()"></app-header>

      <div class="flex-1 z-0 overflow-auto">
        <router-outlet></router-outlet>
      </div>

      <app-footer class="flex-none sticky bottom-0 z-50"></app-footer>

    </div>
  </mat-sidenav-content>

</mat-sidenav-container>
